import React from 'react';

import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import { LIST_TYPE_SURVEY } from 'constants/index';
import { MESSAGE_CREATE_SURVEY } from 'constants/string/messages';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';
import useCreateSurvey from 'hooks/useCreateSurvey';

const SurveyTitle = (props) => {
  const { form, isEdit } = props;
  const { onSaveStep } = useCreateSurvey();

  return (
    <>
      <p className="text-black-102 pb-2 w-full flex items-start gap-1 break-all">
        <img className="mt-2" src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
        {TEXT_CREATE_SURVEY.SURVEY_TYPE}
      </p>
      <Input
        value={form?.values?.period_type || null}
        onChange={(value) => {
          form.setFieldValue(['period_type'], value);
          const question = form.values;
          question.period_type = value;
          onSaveStep(form.values);
        }}
        name="period_type"
        list={LIST_TYPE_SURVEY}
        type="dropdown"
        placeholder={'問診票の種類'}
        className="type-question-select"
        classNameInput="rounded-sm !text-black-102 !font-normal"
        classNameInputOption="rounded-lg !h-8 text-black opacity-85 !font-normal text-base"
        invalid={form?.errors?.period_type}
      />
      {form?.errors?.period_type && !isEdit && (
        <p className="text-sm text-danger-229 max-w-100">{<ErrorMessage>{MESSAGE_CREATE_SURVEY.SURVEY_SELECT_EMPTY}</ErrorMessage>}</p>
      )}
    </>
  );
};

export default React.memo(SurveyTitle);
